module.exports = __webpack_public_path__ + "static/media/btn_add_to_apple_wallet_fr.381ca04b.svg";